export default class Multiselect {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.multiselect'), el => {
			new Multiselect(el);
		});
	}

	isMobile = window.innerWidth < 768;
	groups = [];
	options = [];
	tags = [];
	value = '';
	isOpen = false;
	classes = {
		node: 'multiselect',
		open: 'multiselect--is-open',
		dropdown: 'multiselect__dropdown',
		options: 'multiselect__dropdown-option',
		firstLevelNodes: 'multiselect__dropdown > ul > *',
		controls: 'multiselect__dropdown-controls',
		clearButton: 'multiselect__dropdown-clear',
		applyButton: 'multiselect__dropdown-apply',
		controlsVisible: 'multiselect__dropdown-controls--is-visible',
		field: 'multiselect__input',
		tagsList: 'tag-list',
		tagItem: 'tag-list__item',
		dataHolder: {
			tags: 'multiselect__data-holder-tags',
			input: 'multiselect__data-holder-input'
		}
	}

	constructor(element) {
		if (!element) return;

		this.node = element;
		this.id = this.node.id;
		this.dropdownNode = this.node.querySelector('.' + this.classes.dropdown);
		this.fieldNode = this.node.querySelector('.' + this.classes.field);
		this.controls = this.node.querySelector('.' + this.classes.controls);
		this.clearButtonNode = this.controls.querySelector('.' + this.classes.clearButton);
		this.applyButtonNode = this.controls.querySelector('.' + this.classes.applyButton);
		this.dataHolderTags = this.node.querySelector('.' + this.classes.dataHolder.tags);
		this.dataHolderInput = this.node.querySelector('.' + this.classes.dataHolder.input);
		this.tagsListNode = this.node.querySelector('.' + this.classes.tagsList);

		this.initObjects();
		this.renderValue();

		if (this.isMobile) {
			this.fieldNode.setAttribute('readonly', true);
		}

		// open on focus
		this.fieldNode.addEventListener('focus', (e) => {
			let value = e.target.value;
			this.rewindVisible(value);
			this.open();
		});

		this.fieldNode.addEventListener('input', (e) => {
			this.value = e.target.value
			this.updateValue();
		});

		// search on input
		this.fieldNode.addEventListener('keyup', (e) => this.rewindVisible(e.target.value));

		// remove last rendered tag
		this.fieldNode.addEventListener('keydown', (e) => {
			// backspace pressed with empty value and tags exists
			if (e.keyCode === 8 && e.target.value === '' && this.tags.length) {
				let lastTag = this.tags[this.tags.length - 1];
				lastTag.setInactive();
				if (lastTag) lastTag.option.group.rewindActive();
			}
		});

		// focus on input when clicking inside
		window.addEventListener('click', (e) => {
			if (e.target.isSameNode(document.body)) return;

			let target = e.target;

			if (this.isEventInside(e)) {
				let isApplyButton = target.isSameNode(this.applyButtonNode);
				let isClearButton = target.isSameNode(this.clearButtonNode);

				if (isClearButton) {
					this.clear();
					this.close();
                    this.dataHolderTags.dispatchEvent(new Event('change'));
				}

				if (isApplyButton) {
					console.log(this.getData());
					this.close();
				}

				if (!isApplyButton && !isClearButton) {
					this.open();
				}

				if (!this.isMobile && !isApplyButton && !isClearButton) {
					this.fieldNode.focus();
				}
			} else {
				this.close();
				this.fieldNode.blur();
			}
		});

		// links handler
		window.addEventListener('click', (e) => {
			let target = e.target;

			if (target.dataset.type === 'form-link') {
				e.preventDefault();
				e.stopPropagation();

				if (!target.dataset.tags) return;
				this.clear();

				target.dataset.tags.split(',').forEach(id => {
					let object = this.getObjectById(id)
					if (object) this.setActiveElement(object);
				});
                this.dataHolderTags.dispatchEvent(new Event('change'));
			}
		});

		window.addEventListener('lock', () => {
			this.tagsListNode.style.height = `${this.tagsListNode.getBoundingClientRect().height}px`;
		});
		window.addEventListener('unlock', () => {
			this.tagsListNode.style.height = `100%`;
		});
	}

	initObjects() {
		// parse All Options and Groups
		let firstLevelNodes = this.node.querySelectorAll('.' + this.classes.firstLevelNodes);

		Array.prototype.forEach.call(firstLevelNodes, el => {
			let temp;

			if (el.dataset.type === 'group') {
				temp = new Group(this, el);
				this.groups.push(temp);
				this.options = this.options.concat(temp.options); // collect all levels options including grouped
			}

			if (el.dataset.type === 'option') {
				temp = new Option(this, el)
				this.options.push(temp); // collect first level options
			}
		});
	}

	getData() {
		return {tags: this.dataHolderTags.value, input: this.dataHolderInput.value}
	}

	getObjectById(id) {
		let data = this.groups.concat(this.options);
		return data.find(el => el.id === id) || data.find(el => el.value === id);
	}

	search(val) {
		let data = this.groups.concat(this.options);
		return data.filter(el => el.label.toLowerCase().includes(val.toLowerCase()));
	}

	rewindVisible(value) {
		value = value || '';

		// hide all
		if (value) this.options.forEach(el => el.setInvisible());

		// show matched
		this.search(value).forEach(el => {
			el.highlightText(value);
			el.setVisible();
		});
	}

	open() {
		if (this.isOpen) return;

		if (this.isMobile) window.dispatchEvent(new CustomEvent('lock'));

		this.isOpen = true;
		this.node.classList.add(this.classes.open);
	}

	close() {
		if (!this.isOpen) return;

		if (this.isMobile) window.dispatchEvent(new CustomEvent('unlock'));
		this.isOpen = false;
		this.node.classList.remove(this.classes.open);
	}

	clear() {
		this.fieldNode.value = '';
		this.groups.forEach(el => el.setInactive());
		this.options.forEach(el => el.setInactive());
		this.tags.forEach(el => el.setInactive());
	}

	isEventInside(e) {
		let target = e.target;
		return this.node.contains(target);
	}

	setActiveElement(el) {
		el.setActive();

		if (el.type === 'group') {
			el.setOptionsActive();
		}

		if (el.group) el.group.rewindActive();
	}

	updateValue() {
		let value = [];
		this.tags = [...new Set(this.tags)];
		this.tags.forEach(el => {
			value.push(el.value);
		});
		this.dataHolderTags.value = value.join(',');
		this.dataHolderInput.value = this.value;
	}

	renderValue() {
		let value = this.dataHolderTags.value;

		if (!value) return;
		let tags = value.split(',');
		if (tags.length) tags.forEach(el => this.setActiveElement(this.getObjectById(el)));
	}
}

class Group {
	type = 'group';
	options = [];
	isVisible = true;
	isActive = false;
	classes = {
		active: 'multiselect__dropdown-group--is-active',
		visible: 'multiselect__dropdown-group--is-visible',
		content: 'multiselect__dropdown-group__content'
	}

	constructor(main, groupNode) {
		if (!groupNode) return;

		this.main = main;
		this.node = groupNode;
		this.contentNode = this.node.querySelector('.' + this.classes.content);
		this.id = this.contentNode.dataset.id
		this.label = this.contentNode.dataset.label;
		this.tag = new Tag(this.main, this);

		let tagsValues = '';
		Array.prototype.forEach.call(this.node.querySelectorAll('.' + this.main.classes.options), (el, i) => {
			let option = new Option(this.main, el, this)
			this.options.push(option);
			tagsValues += (i !== 0 ? ',' : '') + option.value;
		});

		this.tag.value = tagsValues;

		this.contentNode.addEventListener('click', () => {
			this.toggleActive();
			this.rewindActive();
            this.main.dataHolderTags.dispatchEvent(new Event('change'));
		});
	}

	highlightText(substr) {
		let text = this.label;
		let index = text.toLowerCase().indexOf(substr.toLowerCase());
		if (index >= 0) {
			text = `${text.substring(0, index)}<span class='highlight'>${text.substring(index, index + substr.length)}</span>${text.substring(index + substr.length)}`;
		}

		this.contentNode.innerHTML = text;
	}

	getTagById(id) {
		return this.options.find(el => el.id === id).tag;
	}

	hasVisibleOption() {
		return this.options.filter(el => el.isVisible).length > 0;
	}

	hasInactiveOption() {
		return this.options.filter(el => !el.isActive).length > 0;
	}

	isAllOptionsActive() {
		return this.options.filter(el => el.isActive).length === this.options.length;
	}

	isAllOptionsInactive() {
		return this.options.filter(el => el.isActive).length === 0;
	}

	rewindActive() {
		if (this.isAllOptionsActive()) {
			this.setActive();

			this.groupTags();
		}

		if (this.hasInactiveOption()) {
			this.setInactive();

			this.ungroupTags();
		}
	}

	toggleActive() {
		this[this.isActive ? 'setOptionsInactive' : 'setOptionsActive']();
		this[this.isActive ? 'setInactive' : 'setActive']();
	}

	groupTags() {
		this.options.forEach(el => el.tag.remove());
		this.tag.setActive();
	}

	ungroupTags() {
		this.tag.setInactive();
		this.options.forEach(el => {
			if (el.isActive) el.tag.add();
		});
	}

	/*setters*/
	setVisible() {
		this.node.classList.add(this.classes.visible);
		this.isVisible = true;
	}

	setInvisible() {
		if (!this.hasVisibleOption()) {
			this.isVisible = false;
			this.node.classList.remove(this.classes.visible);
		}
	}

	setActive() {
		this.node.classList.add(this.classes.active);
		this.isActive = true;
	}

	setInactive() {
		this.node.classList.remove(this.classes.active);
		this.isActive = false;
	}

	setOptionsActive() {
		let inactiveOptions = this.options.filter(el => !el.isActive);
		inactiveOptions.forEach(el => el.setActive());

		this.rewindActive();
	}

	setOptionsInactive() {
		let activeOptions = this.options.filter(el => el.isActive);
		activeOptions.forEach(el => el.setInactive());

		this.rewindActive();
	}
}

class Option {
	type = 'option';
	isVisible = true;
	isActive = false;
	classes = {
		active: 'multiselect__dropdown-option--is-active',
		visible: 'multiselect__dropdown-option--is-visible'
	}

	constructor(main, optionNode, groupObject) {
		if (!optionNode) return;

		this.main = main;
		this.node = optionNode;
		this.group = groupObject;

		this.id = this.node.dataset.id
		this.label = this.node.dataset.label
		this.value = this.node.dataset.value;
		this.tag = new Tag(this.main, this);

		this.node.addEventListener('click', () => {
			this.toggleActive();

			// update group state
			if (!this.group) return;
			this.group.rewindActive();
            this.main.dataHolderTags.dispatchEvent(new Event('change'));
		});
	}

	highlightText(substr) {
		let text = this.label;
		let index = text.toLowerCase().indexOf(substr.toLowerCase());
		if (index >= 0) {
			text = `${text.substring(0, index)}<span class='highlight'>${text.substring(index, index + substr.length)}</span>${text.substring(index + substr.length)}`;
		}

		this.node.innerHTML = text;
	}

	toggleActive() {
		this[this.isActive ? 'setInactive' : 'setActive']();
	}

	/*setters*/
	setActive() {
		this.node.classList.add(this.classes.active);
		this.isActive = true;
		if (!this.tag.isActive) this.tag.setActive();
	}

	setInactive() {
		this.node.classList.remove(this.classes.active);
		this.isActive = false;
		if (this.tag.isActive) this.tag.setInactive();
	}

	setVisible() {
		this.node.classList.add(this.classes.visible);
		this.isVisible = true;
		if (this.group) this.group.setVisible();
	}

	setInvisible() {
		this.node.classList.remove(this.classes.visible);
		this.isVisible = false;
		if (this.group) this.group.setInvisible();
	}
}

class Tag {
	type = 'tag';
	isActive = false;

	constructor(main, option) {
		if (!option) return;

		this.main = main;
		this.option = option;
		this.id = this.option.id;
		this.label = this.option.label;
		this.value = this.option.value;
		this.tagListNode = this.main.tagsListNode;
		this.node = this.create();
	}

	create() {
		let tag = document.createElement('BUTTON');
		tag.classList.add(this.main.classes.tagItem);
		tag.innerHTML = this.label;
		tag.dataset.type = "tag";
		tag.setAttribute('type', 'button');
		tag.setAttribute('title', this.label);
		tag.innerHTML = `${this.label}<span>&times;</span>`;

		tag.addEventListener('click', () => {
			this.setInactive();

			// update group state
			if (!this.option.group) return false;
			this.option.group.rewindActive();
            this.main.dataHolderTags.dispatchEvent(new Event('change'));
		});

		return tag;
	}

	/*setters*/
	setActive() {
		this.add();
		this.main.controls.classList.add(this.main.classes.controlsVisible);
	}

	setInactive() {
		this.remove();
		if (this.option.isActive) this.option[this.option.type === 'group' ? 'setOptionsInactive' : 'setInactive']();
		if (this.main.tags.length === 0) this.main.controls.classList.remove(this.main.classes.controlsVisible);
	}

	remove() {
		this.isActive = false;
		this.node.remove();
		this.main.tags = this.main.tags.filter(el => el.id !== this.id); // remove from rendered tags array
		this.main.updateValue();
	}

	add() {
		this.isActive = true;
		this.tagListNode.appendChild(this.node);
		this.main.tags.push(this); // add to rendered tags array
		this.main.updateValue();
	}
}
